const grassA = {
  grassA1: "hsla(0, 0%, 0%, 0)",
  grassA2: "hsla(107, 97.2%, 61.9%, 0.022)",
  grassA3: "hsla(128, 96.5%, 69.8%, 0.066)",
  grassA4: "hsla(130, 100%, 70.2%, 0.100)",
  grassA5: "hsla(130, 98.2%, 69.1%, 0.140)",
  grassA6: "hsla(132, 99.9%, 69.3%, 0.187)",
  grassA7: "hsla(132, 99.9%, 69.8%, 0.261)",
  grassA8: "hsla(130, 99.6%, 70.5%, 0.370)",
  grassA9: "hsla(130, 99.7%, 70.6%, 0.618)",
  grassA10: "hsla(131, 100%, 73.5%, 0.674)",
  grassA11: "hsla(130, 99.7%, 75.6%, 0.731)",
  grassA12: "hsla(137, 100%, 95.8%, 0.980)"
};
export { grassA };
//# sourceMappingURL=grassA.mjs.map
